<ng-container *ngIf="viewModel$ | async as vm">
  <div class="modal-header">
    <h4 class="modal-title">Select Presence State</h4>
  </div>
  <div class="modal-body">
    <table>
      <tbody>
        <ng-container *ngFor="let state of vm.presenceStates | orderBy: 'description'">
          <tr *ngIf="state.grouping === 'AUX' && state.tenantId > 0">
            <td>
              <input type="radio" name="radiogroup" value="{{ state.id }}" (change)="selectState(state)"
                id="rbt_{{ state.id }}" />
              <label class="ml-2" for="rbt_{{ state.id }}">{{
                state.description
                }}</label>
            </td>
          </tr>
        </ng-container>
        <ng-container *ngIf="vm.showLeavingEarly">
          <tr>
            <td>
              <input type="radio" (change)="showEarlyReasons = true" id="rbt_leavingearly" />
              <label class="ml-2" for="rbt_leavingearly">Leaving Early</label>
            </td>
          </tr>
          <ng-container *ngIf="vm.showEarlyReasons">
            <tr *ngFor="let reason of vm.earlyReasons; index as i">
              <td class="pl-4">
                <input type="radio" (change)="selectLeavingEarly(reason)" id="rbt_reason_{{ i }}" />
                <label class="ml-2" for="rbt_reason_{{ i }}">{{
                  reason
                  }}</label>
              </td>
            </tr>
          </ng-container>
        </ng-container>
        <ng-container *libHasClaim="Unity4Claim.IBTransferOnly">
          <tr *ngIf="vm.ibScheduled">
            <td>
              <input type="radio" name="radiogroup" value="xferonly" (change)="selectIBTransferOnly()"
                id="rbt_xferonly" />
              <label class="ml-2" for="rbt_xferonly">Inbound Transfers Only</label>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="routeToPortal()">
      Exit
    </button>
  </div>
</ng-container>